import { render } from "./MatrizOptions.vue?vue&type=template&id=5391c1be&scoped=true"
import script from "./MatrizOptions.vue?vue&type=script&lang=js"
export * from "./MatrizOptions.vue?vue&type=script&lang=js"

import "./MatrizOptions.vue?vue&type=style&index=0&id=5391c1be&lang=sass&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5391c1be"]])

export default __exports__